<div class="cargando">
    <div class ="i-loader-box">
        <loader-spiner> </loader-spiner>
        <p class="mensaje">{{mensaje}}</p>
    </div>
</div>
